import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

export const useRFQDataQuery = () => {
  const api = useApi()

  return useQuery({
    queryKey: ['rfq', 'data'],
    queryFn: () => api.rfq.getRFQData(),
  })
}

export const useRFQVolQuery = () => {
  const api = useApi()

  return useQuery({
    queryKey: ['rfq', 'vols'],
    queryFn: () => api.rfq.getRFQVol(),
  })
}

export const useRFQRateQuery = () => {
  const api = useApi()

  return useQuery({
    queryKey: ['rfq', 'rates'],
    queryFn: () => api.rfq.getRFQInterestRate(),
  })
}

export const useRFQPricingMatrixQuery = () => {
  const api = useApi()

  return useQuery({
    queryKey: ['rfq', 'pricing-matrix'],
    queryFn: () => api.rfq.getPricingMatrix(),
  })
}
